// ...existing code...
import React from "react";
import "./OurProjects.css";
import aiImg from "../../assets/ai1.png";
import webImg from "../../assets/dev.png";

const ProjectCard = ({ img, alt, title, desc, cta }) => (
  <article className="op-card animate-from-bottom" tabIndex="0" aria-label={title}>
    <div className="op-image" aria-hidden>
      <img src={img} alt={alt} loading="lazy" />
      <div className="op-image-grad" />
    </div>

    <div className="op-body">
      <h3>{title}</h3>
      <p>{desc}</p>
      <div className="op-actions">
       
      </div>
    </div>
  </article>
);

const OurProjects = () => {
  return (
    <section id="our-projects" className="our-projects container">
      <header className="op-header">
        <span className="eyebrow">Our Projects</span>
        <h2>AI & ML and Web Development</h2>
        <p className="op-lead">Practical, secure solutions delivering measurable business outcomes.</p>
      </header>

      <div className="op-grid">
        <ProjectCard
          img={aiImg}
          alt="AI and Machine Learning project"
          title="AI & Machine Learning"
          desc="End-to-end ML pipelines: data engineering, model training, deployment and clinician-friendly explainability."
          cta="/services/ai-ml"
        />

        <ProjectCard
          img={webImg}
          alt="Web development project"
          title="Web Development"
          desc="Modern web platforms using scalable architectures, accessibility-first UI and robust backend services."
          cta="/services/web-development"
        />
      </div>
    </section>
  );
};

export default OurProjects;
// ...existing code...